<div
  *ngIf="
    !isMobile ||
    (isMobile && ((onRouterChange$ | async)?.urlAfterRedirects) | ifAddressIsAvailableOnThePhone)
  "
  id="app-container"
>
  <router-outlet></router-outlet>
</div>
<div *ngIf="isVisibleNotSupportedMobileOsMessage">
  Twój mobilny system operacyjny nie jest wspierany.
  Korzystanie z tej strony możliwe jest wyłącznie na nie mobilnych urządzeniach.
</div>
